module.exports = __webpack_public_path__ + "static/media/pablo.2b0f6287.png";